import {
  STOCK_MASSIVE_UPLOAD_SET_FILE,
  STOCK_MASSIVE_UPLOAD_SET_REJECTED_FILE
} from './constants';

export function setMassiveUploadFile(file, rejected) {
  return (dispatch) => {
    if(!rejected){
      dispatch({
        type: STOCK_MASSIVE_UPLOAD_SET_FILE,
        data: file
      });
    } else {
      dispatch({
        type: STOCK_MASSIVE_UPLOAD_SET_REJECTED_FILE,
        data: file
      });
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_MASSIVE_UPLOAD_SET_FILE:
      if(action.data){
        return {
          ...state,
          massiveUploadFile: action.data,
          fileName: action.data.name
        }
      } else return {
        ...state,
        massiveUploadFile: null,
        fileName: null,
      }
    case STOCK_MASSIVE_UPLOAD_SET_REJECTED_FILE:
      return {
        ...state,
        massiveUploadFile: null,
        fileName: action.data?.name
      }
    default:
      return state;
  }
}
